import { GaugeBands } from "./types";

// Um gauge define-se por UM objetivo. As três zonas derivam-se dele:
// - vermelho: 0 → 80% do objetivo (longe do objetivo)
// - amarelo: 80% → 100% do objetivo (quase a atingir)
// - verde: objetivo → 120% do objetivo (super objetivo)
const ALMOST_GOAL_RATIO = 0.8;
const SUPER_GOAL_RATIO = 1.2;

export const gaugeBandsFromGoal = (goal: number): GaugeBands => {
    const bands = {
        yellowFrom: Math.round(goal * ALMOST_GOAL_RATIO),
        greenFrom: goal,
        max: Math.round(goal * SUPER_GOAL_RATIO),
    };
    return bands;
};
